import * as RadixAccordion from "@radix-ui/react-accordion";
import styled from "styled-components";
import { getThemeFontWeight } from "../helpers";
export const AccordionRoot = styled(RadixAccordion.Root) `
	display: flex;
	flex-direction: column;
	gap: 5px;
`;
export const AccordionItem = styled(RadixAccordion.Item) `
	border: 1px solid var(--border-primary);
	background: var(--surface-white);
	border-radius: 8px;
	padding-left: 15px;
	padding-right: 15px;
`;
export const AccordionTrigger = styled(RadixAccordion.Trigger) `
	cursor: pointer;
	display: flex;
	align-items: center;
	font-weight: ${getThemeFontWeight("regular")};
	padding: 0;
	padding-top: 15px;
	padding-right: 45px;
	padding-bottom: 15px;
	width: 100%;
	text-align: left;
	position: relative;

	svg {
		transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
		position: absolute;
		right: 15px;
	}

	&[data-state='open'] {
		svg {
			transform: rotate(90deg);
		}
	}
`;
export const AccordionContent = styled(RadixAccordion.Content) `
	border-top: 1px solid var(--border-primary);
	margin-bottom: 15px;
	padding-top: 15px;

	p::first-letter {
		text-transform: uppercase;
	}
`;
//# sourceMappingURL=styles.js.map